export default {
  IDLE: 'IDLE',
  OPEN_SOCKET: 'OPEN_SOCKET',
  INIT: 'INIT',
  LOADING: 'LOADING',
  MAKE_BETS: 'MAKE_BETS',
  ROUND_START: 'ROUND_START',
  ROUND_END: 'ROUND_END',
  START_FEATURE: 'START_FEATURE',
  STOP_FEATURE: 'STOP_FEATURE',
  RECONNECT_SOCKET: 'RECONNECT_SOCKET'
}
